export const commaHandler = (listLength, index) => {
	if (listLength > 1 && index !== listLength - 1) {
		return ', ';
	}
	return '';
};